import {
    CheckCircleIcon,
    AlertCircleIcon,
    LightbulbIcon,
    FileTextIcon,
    ClipboardListIcon,
} from "lucide-react";

export type EmptyStateType = "matches" | "lacking" | "improvements";

interface Props {
    type: EmptyStateType;
}

export default function CandidateEmptyInsight({ type }: Props) {
    // Configuration for different empty states
    const stateConfig = {
        matches: {
            icon: <CheckCircleIcon className="h-8 w-8 text-gray-500" />,

            bgColor: "bg-gray-100",
            title: "No matches found.",
            description:
                "We could not find any matches between your profile and the job requirements.",
            action: (
                <div className="flex items-center text-sm text-blue-600">
                    <FileTextIcon className="h-4 w-4 mr-1" />

                    <span>Update your resume to highlight relevant skills.</span>
                </div>
            ),
        },
        lacking: {
            icon: <AlertCircleIcon className="h-8 w-8 text-gray-500" />,

            bgColor: "bg-gray-100",
            title: "No gaps detected.",
            description: "We could not find any lacking areas from your profile.",
            action: (
                <div className="flex items-center text-sm text-blue-600">
                    <FileTextIcon className="h-4 w-4 mr-1" />

                    <span>Refine your profile for stronger positioning.</span>
                </div>
            ),
        },
        improvements: {
            icon: <LightbulbIcon className="h-8 w-8 text-gray-500" />,

            bgColor: "bg-gray-100",
            title: "No improvement suggestions.",
            description:
                "We could not identify any improvement suggestions at this time.",
            action: (
                <div className="flex items-center text-sm text-blue-600">
                    <ClipboardListIcon className="h-4 w-4 mr-1" />

                    <span>Update your profile regularly for personalized tips.</span>
                </div>
            ),
        },
    };

    const config = stateConfig[type];

    return (
        <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className={`${config.bgColor} rounded-full p-4 mb-4`}>
                {config.icon}
            </div>
            <h3
                className={`text-lg font-medium mb-2 ${type === "lacking" ? "text-blue-800" : "text-gray-900"
                    }`}
                style={{ color: "#27272a" }}
            >
                {config.title}
            </h3>
            <p
                className={`text-sm max-w-md mb-4 ${type === "lacking" ? "text-blue-700" : "text-gray-500"
                    }`}
                style={{ color: "#6b7280" }}
            >
                {config.description}
            </p>
            {config.action}
        </div>
    );
}
